/** External store for call countdowns — avoids 1s CallMediaContext thrash. */

const listeners = new Set();

let snapshot = {
  closeInSeconds: null,
  startInSeconds: null,
  sessionStarted: true,
};

export const getCallTiming = () => snapshot;

export const subscribeCallTiming = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export const setCallTiming = (partial) => {
  const next = { ...snapshot, ...partial };
  if (
    next.closeInSeconds === snapshot.closeInSeconds &&
    next.startInSeconds === snapshot.startInSeconds &&
    next.sessionStarted === snapshot.sessionStarted
  ) {
    return;
  }
  snapshot = next;
  listeners.forEach((l) => {
    try {
      l();
    } catch (_) {}
  });
};

export const resetCallTiming = () => {
  snapshot = {
    closeInSeconds: null,
    startInSeconds: null,
    sessionStarted: true,
  };
  listeners.forEach((l) => {
    try {
      l();
    } catch (_) {}
  });
};
